import React, { PropsWithChildren, useEffect, useRef, useState } from 'react';
import { Tooltip } from 'edenred-ui';
import { TooltipProps } from 'edenred-ui/components/Tooltip/Tooltip';

import { StyledOverflowTooltipContent } from './OverflowTooltip.styles';

const OverflowTooltip = ({
  children,
  ...tooltipProps
}: PropsWithChildren<TooltipProps>) => {
  const textElementRef = useRef<HTMLDivElement>(null);
  const [isOverflow, setIsOverflow] = useState(false);

  const compareSize = () => {
    if (textElementRef.current) {
      const compare =
        textElementRef.current.scrollWidth > textElementRef.current.clientWidth;

      setIsOverflow(compare);
    }
  };

  useEffect(() => {
    compareSize();
  }, [tooltipProps.title]);

  useEffect(() => {
    window.addEventListener('resize', compareSize);
    return () => {
      window.removeEventListener('resize', compareSize);
    };
  }, []);

  return (
    <Tooltip disableHoverListener={!isOverflow} {...tooltipProps}>
      <StyledOverflowTooltipContent ref={textElementRef} $addMask={isOverflow}>
        {children}
      </StyledOverflowTooltipContent>
    </Tooltip>
  );
};

export { OverflowTooltip };
